import React from 'react'

type Props = React.SVGProps<SVGSVGElement> & { color?: string }

export default function AshLogo({ color = 'white', ...props }: Props) {
  return (
    <svg
      width="80"
      height="40"
      viewBox="0 0 80 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color }}
      {...props}
    >
      <g clipPath="url(#clip0_6955_1414)">
        <path
          d="M42.376 22.8026C39.5321 21.9975 37.6188 20.9921 37.5211 18.8297C37.4722 17.0192 38.8447 15.3101 41.3455 15.3101C43.9053 15.26 45.179 16.8211 45.2176 18.8856C45.2176 18.8915 45.2176 18.8961 45.2176 18.9019C45.2176 20.3303 46.347 21.4884 47.7399 21.4884H50.2623V18.9812C50.2623 18.9812 50.2645 18.9031 50.2623 18.8635C50.26 18.7249 50.2475 18.5885 50.2248 18.4557C49.5965 12.79 44.9654 11.0366 41.3955 11.0366C36.5406 11.0366 32.4219 14.1543 32.4219 19.333C32.4707 23.4562 35.4135 25.2667 39.1401 26.4224C43.8962 28.0313 45.9073 28.9366 45.9561 31.6524C45.9561 33.965 44.0439 35.7254 41.592 35.7254C39.6798 35.7254 37.0802 34.6186 36.8848 31.3005H36.8791C36.878 29.8733 35.7486 28.7164 34.3568 28.7164H31.8345V31.3028C31.8345 31.396 31.8402 31.4892 31.8492 31.5801C32.2378 37.6093 37.3904 40 41.5443 40C46.8401 40 51.1553 36.3802 51.0576 31.05C50.911 25.1665 46.4481 23.9606 42.3783 22.8037L42.376 22.8026Z"
          fill="currentColor"
        />
        <path
          d="M13.6021 11.6205C6.08963 11.6205 -0.00146484 17.8652 -0.00146484 25.5697C-0.00146484 33.2743 6.08849 39.519 13.6021 39.519C17.097 39.519 20.2851 38.1664 22.6939 35.9446V39.519H27.2045V25.5709V11.6205H13.601H13.6021ZM22.6939 25.5686C22.6939 30.7181 18.6229 34.8914 13.6021 34.8914C8.58129 34.8914 4.51033 30.717 4.51033 25.5686C4.51033 20.4202 8.58129 16.2458 13.6021 16.2458H22.6939V25.5686Z"
          fill="currentColor"
        />
        <path
          d="M79.9989 36.6611V24.3662C79.9989 20.5949 79.3615 17.327 77.6936 14.963C75.9768 12.549 73.3295 11.1417 69.1608 11.1417C65.6796 11.0916 62.4948 11.638 60.4815 13.7828V2.61458C60.4815 2.94545 60.4815 2.94545 60.4815 2.61458V0.000183105H57.9319C56.5242 0.000183105 55.3823 1.17107 55.3823 2.61458C55.3823 3.21653 55.3823 3.21653 55.3823 2.61458V36.66V36.6844V39.2988H57.9319C59.3397 39.2988 60.4815 38.1279 60.4815 36.6844V23.8618C60.4815 22.0012 60.9724 20.0404 62.0995 18.5817C63.1788 17.1231 65.041 16.0675 67.7383 16.0675C70.4357 16.0675 72.1513 16.9728 73.3284 18.4815C74.4066 19.9903 74.8486 22.1526 74.8486 24.6156L74.8509 36.6588V39.2977H77.4243C78.8457 39.2977 79.9978 38.1163 79.9978 36.6588L79.9989 36.6611Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_6955_1414">
          <rect width="80" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
